export const $$inquirySymbol: unique symbol = Symbol();
export const $$questionsetSymbol: unique symbol = Symbol();
export const $$questionSymbol: unique symbol = Symbol();
export const $$passSymbol: unique symbol = Symbol();
export const $$failSymbol: unique symbol = Symbol();
export const $$iouSymbol: unique symbol = Symbol();
export const $$receiptSymbol: unique symbol = Symbol();